<template>
  <div class="padding-five-all">
    <b-container fluid>
      <!-- ================= FILTROS ================= -->
      <b-row>
        <b-col cols="12" lg="3">
          <label class="font-weight-bold">Generada desde</label>
          <b-form-input type="date" v-model="startDate" />
        </b-col>

        <b-col cols="12" lg="3">
          <label class="font-weight-bold">Generada hasta</label>
          <b-form-input type="date" v-model="endDate" />
        </b-col>

        <b-col cols="12" lg="3">
          <label class="font-weight-bold">Tienda</label>
          <combo-store
            v-model="selectedStore"
            v-bind:isComboSelected="false"
          ></combo-store>
        </b-col>

        <b-col cols="12" lg="3" class="d-flex align-items-end">
          <b-button variant="dark" class="width-100" @click="buscar">
            Buscar
          </b-button>
        </b-col>
      </b-row>

      <!-- ================= TABLA ================= -->
      <b-row class="mt-3">
        <b-col>
          <b-table
            bordered
            responsive="xl"
            show-empty
            :busy="isBusy"
            :items="items"
            :fields="fields"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle" />
                <strong>Cargando...</strong>
              </div>
            </template>

            <template #cell(fechaGeneracion)="row">
              {{ formatDate(row.item.fechaGeneracion) }}
            </template>

            <!-- ACCIONES -->
            <template #cell(actions)="row">
              <b-button
                size="sm"
                variant="primary"
                @click="verDetalle(row.item)"
              >
                Ver detalle
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import ComboStore from "../../components/ComboStore.vue";

export default {
  name: "LiquidacionesAdministrativo",

  data() {
    return {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      selectedStore: 0,

      tiendas: [
        { value: null, text: "Seleccione tienda" },
        // 👉 cargar dinámicamente
      ],

      isBusy: false,
      items: [],

      fields: [
        { key: "idLiquidacion", label: "Liquidación" },
        { key: "nombreProveedor", label: "Proveedor" },
        { key: "nombreTienda", label: "Tienda" },
        { key: "fechaGeneracion", label: "Fecha generación" },
        { key: "cantidadOS", label: "Cant. OS", class: "text-center" },
        { key: "actions", label: "Acciones", class: "text-center" },
      ],
    };
  },
  components: { ComboStore },
  computed: {
    ...mapState("module", ["perfil"]),
  },

  mounted() {
    if (this.perfil !== "HP") {
      this.$router.replace("/404");
      return;
    }
  },

  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    async buscar() {
      this.isBusy = true;
      const params = {
        fechaInicio: this.startDate,
        fechaFin: this.endDate,
      };

      if (this.selectedStore) {
        params.idTienda = this.selectedStore;
      }
      try {
        const {
          data,
        } = await axios.get(
          `${process.env.VUE_APP_REPORT_VTEX_BASE}/hp/service-system/v1/liquidaciones/administrativo`,
          { params }
        );

        this.items = data || [];
      } catch (error) {
        console.error(error);
        this.$bvToast.toast("Error al obtener liquidaciones administrativas", {
          variant: "danger",
          solid: true,
        });
      } finally {
        this.isBusy = false;
      }
    },

    verDetalle(item) {
        console.log(item)
      this.$router.push(
        `/liquidaciones/administrativo/${item.idLiquidacion}/tienda/${item.idTienda}`
      );
    },
  },
};
</script>
<style scoped>
.width-100 {
  width: 100%;
}
</style>
